import { createSelector } from 'reselect';
import type { DomCouponState } from '@travel/traveler-core/store/dom-coupon/types';

/**
 * Selector factory that creates typed selectors for any RootState shape.
 * Usage: const selectors = createPromotionListSelectors((state) => state.promotionList);
 */
export const createDomCouponSelectors = <RootState>(
  selectSlice: (state: RootState) => DomCouponState,
) => {
  // Selectors that take providerId as parameter
  const getIsFetching = (providerId: number) =>
    createSelector(selectSlice, (state) => {
      return state[providerId]?.isFetching || false;
    });

  const getError = (providerId: number) =>
    createSelector(selectSlice, (state) => {
      return state[providerId]?.error || null;
    });

  const getData = (providerId: number) =>
    createSelector(selectSlice, (state) => {
      return state[providerId]?.data || null;
    });

  // Get all data (for debugging or bulk operations)
  const getAllData = createSelector(selectSlice, (state) => state);

  return {
    getIsFetching,
    getError,
    getData,
    getAllData,
  };
};
